export const SORT_FIELD_NONE = "none";

export const DEFAULT_OWNER_SORT_CRITERIA = [
  { field: "year", direction: "asc" },
  { field: "denomination", direction: "asc" },
];

const normalizeText = (value) => String(value || "")
  .normalize("NFKD")
  .replace(/[\u0300-\u036f]/g, "")
  .trim()
  .toLowerCase();

const compareNullableNumbers = (a, b, direction = "asc") => {
  const aMissing = a === null || a === undefined;
  const bMissing = b === null || b === undefined;
  if (aMissing && bMissing) return 0;
  if (aMissing) return 1;
  if (bMissing) return -1;
  return direction === "asc" ? a - b : b - a;
};

const compareNullableStrings = (a, b, direction = "asc") => {
  const left = normalizeText(a);
  const right = normalizeText(b);
  const leftMissing = !left;
  const rightMissing = !right;
  if (leftMissing && rightMissing) return 0;
  if (leftMissing) return 1;
  if (rightMissing) return -1;
  return direction === "asc" ? left.localeCompare(right) : right.localeCompare(left);
};

export const compareOwnerItemsByField = (a, b, field, direction = "asc") => {
  switch (field) {
    case "title":
      return compareNullableStrings(a.__title, b.__title, direction);
    case "grade":
      return compareNullableStrings(a.__grade, b.__grade, direction);
    case "year":
      return compareNullableNumbers(a.__year, b.__year, direction);
    case "denomination":
      return compareNullableStrings(a.__denomination, b.__denomination, direction);
    case "country":
      return compareNullableStrings(a.__country, b.__country, direction);
    case "mintage":
      return compareNullableNumbers(a.__mintage, b.__mintage, direction);
    case "date_added":
    default:
      return compareNullableNumbers(a.__dateAddedEpoch, b.__dateAddedEpoch, direction);
  }
};

export const normalizeOwnerSortCriteria = (criteria = []) => criteria
  .filter((criterion) => criterion?.field && criterion.field !== SORT_FIELD_NONE)
  .map((criterion) => ({
    field: criterion.field,
    direction: criterion.direction === "desc" ? "desc" : "asc",
  }));

export const sortOwnerItems = (items, criteria = DEFAULT_OWNER_SORT_CRITERIA) => {
  const activeCriteria = normalizeOwnerSortCriteria(criteria);
  const criteriaWithTieBreaker = [
    ...activeCriteria,
    { field: "date_added", direction: "desc" },
  ];
  const clone = [...items];
  clone.sort((a, b) => {
    for (const criterion of criteriaWithTieBreaker) {
      const result = compareOwnerItemsByField(a, b, criterion.field, criterion.direction);
      if (result !== 0) return result;
    }
    return 0;
  });
  return clone;
};
